import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Trash, PencilSimple, X } from "@phosphor-icons/react";

export default function BulkActionBar({ count, collection, selectedIds, onComplete, statuses = [] }) {
  const [bulkStatus, setBulkStatus] = useState("");

  if (count === 0) return null;

  const handleDelete = async () => {
    if (!window.confirm(`Delete ${count} selected items?`)) return;
    try {
      const { data } = await api.post("/bulk/delete", { collection, ids: Array.from(selectedIds) });
      toast.success(`Deleted ${data.deleted} items`);
      onComplete();
    } catch { toast.error("Bulk delete failed"); }
  };

  const handleStatusChange = async () => {
    if (!bulkStatus) { toast.error("Select a status"); return; }
    try {
      const { data } = await api.post("/bulk/update-status", { collection, ids: Array.from(selectedIds), status: bulkStatus });
      toast.success(`Updated ${data.updated} items to "${bulkStatus}"`);
      setBulkStatus("");
      onComplete();
    } catch { toast.error("Bulk status update failed"); }
  };

  return (
    <div className="fixed bottom-0 left-[240px] right-0 bg-[#1A1D20] text-white px-6 pr-52 py-3 flex items-center justify-between z-[999] border-t border-gray-700" data-testid="bulk-action-bar">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium">{count} selected</span>
        <button data-testid="bulk-clear-btn" onClick={onComplete} className="text-xs text-gray-400 hover:text-white flex items-center gap-1"><X size={12} /> Clear</button>
      </div>
      <div className="flex items-center gap-3">
        {statuses.length > 0 && (
          <div className="flex items-center gap-2">
            <Select value={bulkStatus} onValueChange={setBulkStatus}>
              <SelectTrigger data-testid="bulk-status-select" className="rounded-none w-[140px] bg-gray-800 border-gray-600 text-white text-xs h-8">
                <SelectValue placeholder="Set status..." />
              </SelectTrigger>
              <SelectContent className="rounded-none">
                {statuses.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}
              </SelectContent>
            </Select>
            <button data-testid="bulk-status-btn" onClick={handleStatusChange}
              className="bg-[#002FA7] text-white hover:bg-[#002480] rounded-none font-medium px-3 py-1.5 text-xs flex items-center gap-1">
              <PencilSimple size={12} /> Apply
            </button>
          </div>
        )}
        <button data-testid="bulk-delete-btn" onClick={handleDelete}
          className="bg-[#FF2A00] text-white hover:bg-[#CC2200] rounded-none font-medium px-3 py-1.5 text-xs flex items-center gap-1">
          <Trash size={12} /> Delete Selected
        </button>
      </div>
    </div>
  );
}
